import { alpha } from "@mui/material";

// eslint-disable-next-line import/no-anonymous-default-export
export default (theme) => ({
  resetedSignHolder: {
    position: "relative",
    width: "100%",
  },
  resetSign: {
    color: theme.palette.grey[600],
    flex: 1,
    textAlign: "center",
    padding: "15px 0",
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
    marginBottom: 20,
  },
  mainChatWrapper: {
    width: "100%",
    margin: "auto",
    position: "relative",
    height: "100%",
    overflow: "hidden",
  },
  inputWrapper: {
    position: "absolute",
    left: "50%",
    display: "flex",
    width: "95%",
    maxWidth: "800px",
    transform: "translateX(-50%)",
    bottom: 22,
    background:
      theme.palette.mode === "light"
        ? theme.palette.background.default
        : theme.palette.background.dark,
    borderRadius: "25px",
    boxShadow: "0 0px 25px -2px #d7dee5",
    [theme.breakpoints.down("sm")]: {
      padding: 2,
    },
  },
  chatHolder: {
    flex: 1,
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "100%",
    backgroundColor: "#eff1f3",
    border: "4px solid #fff",
    overflow: "hidden",
    boxShadow: "0 0px 12px -4px #a6aaad",
  },
  chatAlert: {
    position: "absolute",
    zIndex: 1,
    mt: 5,
    width: 450,
    left: "50%",
    transform: "translateX(-50%)",
  },
  messageHolder: {
    "& > div:last-child": {
      marginBottom: 80,
    },
    "& > div:first-child": {
      marginTop: 25,
    },
  },
  botMessage: {
    padding: 15,
    width: "93%",
    maxWidth: "800px",
    position: "relative",
    margin: "auto",
    borderRadius: theme.shape.borderRadiusMd,
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.background.default
        : "#212a35",
    color:
      theme.palette.mode === "light"
        ? theme.palette.text.main
        : alpha(theme.palette.text.primary, 0.75),
    fontSize: ".95rem",
    lineHeight: "1.6rem",
    wordWrap: "break-word",
    "& .tableWrapper": {
      overflowX: "auto",
      marginTop: 10,
    },
    "& table": {
      borderSpacing: 0,
      borderRadius: 3,
      minWidth: "100%",
    },
    "& table th": {
      background: "rgba(201 201 201 / 0.1)",
      border: ".5px solid rgba(128, 128, 128, 0.4)",
      padding: "5px 10px",
      whiteSpace: "nowrap",
    },
    "& table td": {
      border: ".5px solid rgba(128, 128, 128, 0.4)",
      padding: 5,
    },
    "& ul": {
      listStylePosition: "inside",
      margin: "10px 0 10px 20px",
    },
    "& ol": {
      margin: "10px 0 10px 25px",
    },
    "& hr": {
      margin: "15px 0 15px 0",
      opacity: 0.25,
    },
    "& ::marker": {
      color: alpha(theme.palette.text.primary, 0.5),
    },
    "& img": {
      borderRadius: 5,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: ".9rem",
      width: "95%",
    },
  },
  userMessage: {
    borderRadius: 12.5,
    borderTopRightRadius: 0,
    padding: "10px 15px",
    width: "94%",
    maxWidth: "800px",
    margin: "auto",
    color: theme.palette.text.primary,
    fontSize: ".95rem",
    lineHeight: "1.6rem",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      fontSize: ".9rem",
      width: "95%",
    },
  },
  messageTimestamp: {
    opacity: 0.55,
    marginRight: "auto",
  },
  feedbackBox: {
    padding: 10,
    width: "400px",
    background: theme.palette.background.light,
  },
  thumbIcon: {
    height: "15px",
    width: "15px",
    pointerEvents: "none",
  },
  thumbContainer: {
    display: "flex",
    alignItems: "center",
  },
  chatHeader: {
    padding: 14,
    marginBottom: "2px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    boxShadow: "2px 2px 4px #0000001a",
  },
  chatbotLoader: {
    display: "flex",
    justifyContent: "flex-start",
    marginRight: "6px",
    width: 40,
  },
  chatbotLoaderDot: {
    fill: theme.palette.text.secondary,
  },
  chatConfigContainer: {
    position: "absolute",
    border: "3px solid #eaebec",
    padding: "17px",
    top: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#fff",
    zIndex: 1000,
    width: "100%",
    height: "100%",
  },
  chatConfigItem: {
    margin: "16px auto",
    padding: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    position: "relative",
  },
});
